import { keyframes } from "@mui/material";

// Shared animation for spinning effects
export const spinAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;